<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/admin">admin</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  provide() {
    return{
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    //this.isLogin();
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
/* * {cursor: none;} */
html {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family:"Microsoft YaHei";
  position: relative;

}
body {
  height: 100%;
  width: 100%;
  overflow: auto;
  margin: 0;
  padding: 0;
  position: relative;
}
#app {
  height: 100%;
  width: 100%;
  overflow: auto;
  position: relative;
}
a{
  text-decoration: none;
  color: inherit;
}
*{
  outline: none;
}
</style>
